import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import Card from '../../components/card.component';
import DataTableExtensions from 'react-data-table-component-extensions';
import DataTable from 'react-data-table-component';
import * as table from './tipos_salidas.table';
import functionApi from './tipos_salidas.function';
import TiposSalidasForm from './tipos_salidas.form';
import notification from '../../components/notification.component';
import { ConfigContext } from '../../context/config.context';


const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const TiposSalidasView = () => {

  const { config } = useContext(ConfigContext);

  const [data, setData] = useState([]);
  const [updateValues, setUpdateValues] = useState(null); 

  const getList = useCallback(async () => {
    const list = await functionApi.listV2();
    setData(list.data.tipos);
  },[]);

  useEffect(() => {
    getList();
  },[]);

  const editAction = (item) => {
    setUpdateValues(item);
  }

  const disabledAction = (item) => {
    const payload = {
      id: item.id,
      status: item.status === '1' ? "0" : '1',
    }

    functionApi.update(payload)
    .then((response) => {
      notification.success('Estado de salida actualizado');
      getList();
    })
  }

  return (
    <Card>
      <Row>
        <Col>
          <h4>Tipos de salidas</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <TiposSalidasForm 
            updateValues={updateValues}
            refreshData={getList}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DataTableExtensions
              columns={table.colummns(editAction, disabledAction, config)}
              data={data}
              export={false}
              print={false}
              filterPlaceholder="Buscar tipo de salida"
            >
                <DataTable
                  noHeader
                  customStyles={customStyles}
                  dense={true}
                  pagination={true}
                  paginationPerPage={50}
                  noDataComponent={"Sin datos asociados"}
                  style={{ 
                    minHeight: 400,
                  }}
              />
            </DataTableExtensions>
        </Col>
      </Row>
    </Card>
  )
}

export default TiposSalidasView;